var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.093,
    height: 16.093,
    viewBox: "0 0 16.093 16.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Help",
    d: "M11.047,3a8.047,8.047,0,1,0,8.047,8.047A8.047,8.047,0,0,0,11.047,3Zm0,13.076a1.006,1.006,0,1,1,1.006-1.006A1.006,1.006,0,0,1,11.047,16.076Zm1.387-4.694c-.444.41-.716.679-.716,1.006H10.376A2.742,2.742,0,0,1,11.523,10.4c.536-.495.864-.825.864-1.361a1.341,1.341,0,0,0-2.682,0H8.364a2.682,2.682,0,1,1,5.364,0A3.119,3.119,0,0,1,12.433,11.382Z",
    transform: "translate(-3 -3)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.d5cc5379ea642e216391638e416c1704.svg";
export { ForwardRef as ReactComponent };